<template>
  <div class="body">
    <div class="list-tab">
      <div class="tab-item" :class="tab == 1 ? 'item-click' : ''" @click="tab = 1">
        <span>沟通过</span>
        <div v-if="tab == 1" class="l"></div>
      </div>
      <div class="tab-item" :class="tab == 2 ? 'item-click' : ''" @click="tab = 2">
        <span>找客户</span>
        <div v-if="tab == 2" class="l"></div>
      </div>
    </div>
    <roomList v-if="tab == 1"></roomList>
    <onlineList v-if="tab == 2"></onlineList>
  </div>
</template>
<script>
import roomList from "@/views/2184/clerk/chat/roomList"
import onlineList from "@/views/2184/clerk/chat/onlineList"
import Vue from 'vue';
import { Tab, Tabs } from 'vant';
Vue.use(Tab);
Vue.use(Tabs);
export default {
  components: {
    roomList, onlineList
  },
  data() {
    return {
      tab: 1,
    }
  },
}
</script>
<style lang="less" scoped>
.body{
  min-height: 100vh;
  background: #fff;
  .list-tab{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 12vw;
    color: #999;
    font-size: 3.7vw;
    line-height: 3.7vw;
    border-bottom: 1px #F0F0F0 solid;
    .tab-item{
      position: relative;
      .l{
        position: absolute;
        bottom: -2.6vw;
        left: 50%;
        transform: translate(-50%,100%);
        height: 0.5vw;
        width: 11.2vw;
        border-radius: 999px;
        background: var(--primary-color);
      }
    }
    .item-click{
      color: #333;
      font-weight: bold;
    }
  }
}
</style>
